import { Outlet, createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

// Ruta layout transparente — solo pasa el contenido hijo sin añadir navegación
// de tabs ni header propio. Clientes es un módulo independiente de Proveedores.
export const Route = createFileRoute('/_app/clients')({
  component: ClientsLayout,
})

function ClientsLayout(): JSX.Element {
  return <Outlet />
}
